module.exports = __webpack_public_path__ + "static/mobile-device-background-09f81ca126a573539456c386bdf29a02.png";